import React from 'react'
import MappingSelect from '../../Components/MappingSelect'
import MappingCheckbox from '../../Components/MappingCheckbox'
import Shared from '../../mappingUi.module.css'
import Style from '../methodMapping.module.css'

const MethodMappingRow = ({ row, idPrefix, erpMethods, ecommerceMethods, isDisabled, onChange, onRemove }) => (
    <li className={[Shared.row, row.isNew ? Shared.rowNew : ''].join(' ').trim()}>
        <div className={`${Shared.grid} ${Style.grid}`}>
            <MappingSelect
                inputId={`${idPrefix}ErpMethod-${row.rowId}`}
                options={erpMethods}
                value={row.erpMethod}
                placeholder="Select ERP Method"
                customLabel="Custom ERP Method"
                customPlaceholder="Enter ERP method"
                hasError={row.erpMethod === ''}
                isDisabled={isDisabled}
                onChange={(value) => onChange(row.rowId, { erpMethod: value })}
            />
            <span className={Shared.arrow} aria-hidden="true">&rarr;</span>
            <MappingSelect
                inputId={`${idPrefix}EcommerceMethod-${row.rowId}`}
                options={ecommerceMethods}
                value={row.ecommerceMethod}
                placeholder="Select eCommerce Method"
                customLabel="Custom eCommerce Method"
                customPlaceholder="Enter eCommerce method"
                hasError={row.ecommerceMethod === ''}
                isDisabled={isDisabled}
                onChange={(value) => onChange(row.rowId, { ecommerceMethod: value })}
            />
            <MappingCheckbox
                inputId={`${idPrefix}IsEcommerceDefault-${row.rowId}`}
                label="ERP-Ecom"
                checked={row.isEcommerceDefault}
                isDisabled={isDisabled}
                onChange={(checked) => onChange(row.rowId, { isEcommerceDefault: checked })}
            />
            <MappingCheckbox
                inputId={`${idPrefix}IsErpDefault-${row.rowId}`}
                label="Ecom-ERP"
                checked={row.isErpDefault}
                isDisabled={isDisabled}
                onChange={(checked) => onChange(row.rowId, { isErpDefault: checked })}
            />
            <button
                type="button"
                className={Shared.deleteButton}
                title="Remove mapping"
                aria-label={`Remove mapping for ${row.erpMethod || 'this row'}`}
                disabled={isDisabled}
                onClick={() => onRemove(row.rowId)}
            >
                <i className="uil-trash-alt" aria-hidden="true" />
            </button>
        </div>
        {row.isNew ? <span className={Shared.newBadge}>Not saved yet</span> : null}
    </li>
)

export default React.memo(MethodMappingRow)
